import React from 'react'
import { Link } from "react-router-dom";

export default function Products() {
  return (

<ul>
<li><Link to='/travel-tourism-b2b'>Travel & Tourism B2B</Link></li>
<li><Link to='/travel-tourism-b2c'>Travel & Tourism B2C</Link></li>
<li><Link to='/travel-tourism-corporate-booking-portal'>Travel & Tourism Corporate Booking Portal</Link></li>
<li><Link to='/flight-inventory-management-system'>Flight Inventory Management System</Link></li>
<li><Link to='/robotic-process-automation'>Robotic Process Automation</Link></li>
<li><Link to='/gds-process-automation-tools'>GDS Process Automation Tools</Link></li>
{/* <li><Link to='/package-management-distribution'>Package Management and Distribution</Link></li> */}
{/* <li><Link to='/expense-management'>Expense Management</Link></li> */}
<li><Link to='/ndc'>NDC</Link></li>
<li><Link to='/travel-tourism-finance'>Travel & Tourism Finance</Link></li>
<li><Link to='/healthcare-hyperautomation'>Healthcare Solutions & Hyperautomation</Link></li>



</ul>
  )
}





















